var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.191 0C36.52 0 37.6.9 37.6 2v16c0 1.1-1.081 2-2.409 2H2.41C1.08 20 0 19.1 0 18V2C0 .9 1.081 0 2.409 0z",
    fill: "#3c4043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.197.8H2.403C1.532.8.823 1.371.8 2.078v15.805c0 .717.697 1.298 1.568 1.317h32.83c.87 0 1.579-.571 1.602-1.278V2.117C36.8 1.4 36.103.82 35.232.8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 7.5a2 2 0 100-4 2 2 0 000 4zm-28-4h5v4H4zm0 7h30V13H4zm0 5h2.75v1.25H4zm4 0h2.75v1.25H8z",
    fill: "#000"
  }))));
}

export default __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/credit-card-icon-0d7e131e589ff3ac3259554164a832d1.svg";
export { SvgCreditCardIcon as Component };